module.exports = __webpack_public_path__ + "static/vuejs-bf510438da8c5b283e20dfc745e7d9db.png";